import { ensureNotNil } from "client/Misc/utils";
import { ReactElement, useMemo } from "react";
import { createRoot } from "react-dom/client";
import {
	createBrowserRouter,
	DataRouter,
	Outlet,
	RouterProvider
} from "react-router";
import { getRelativeEnvironmentUrl } from "client_legacy/ndaw/navigator";
import { App } from "./App";
import { NavigationLinkContext, NavigationLinkContextData } from "client/Contexts/NavigationLinkContext";
import { RouterNavigationLink } from "./RouterNavigationLink";
import { appRoutes } from "./appRoutes";

export const SpaEndpoint = (): ReactElement => {
	return (
		<RouterProvider router={router} />
	);
};
SpaEndpoint.displayName = "SpaEndpoint";

const Root = (): ReactElement => {
	const navigationLinkContextData = useMemo(
		(): NavigationLinkContextData => {
			return {
				render(props, ref): ReactElement {
					return (
						<RouterNavigationLink
							{...props}
							ref={ref}
						/>
					);
				},
			};
		},
		[]
	);

	return (
		<App>
			<NavigationLinkContext.Provider value={navigationLinkContextData}>
				<Outlet />
			</NavigationLinkContext.Provider>
		</App>
	);
};
Root.displayName = "Root";

const baseUrl: string = getRelativeEnvironmentUrl();

const router: DataRouter = createBrowserRouter(
	[
		{
			path: "/",
			element: <Root />,
			children: appRoutes
		}
	],
	{
		basename: baseUrl
	}
);

export function init(): void {
	createRoot(
		ensureNotNil(
			document.querySelector(".app-layout__body")
		)
	)
		.render(
			<SpaEndpoint />
		);
}